<template>
    <form>
        <ui-container>
            <ui-form-section :title="editMode ? `Updating ${item.name}` : 'Add new key'" subtitle="Provide the main details of the Key in this section." class="py-8 border-b">
                <ui-input label="Name" name="name" :error="form.errors.get('name')" v-model="form.name" class="xl:col-span-6"></ui-input>
                <ui-input label="Reference" name="reference" :error="form.errors.get('reference')" v-model="form.reference" class="xl:col-span-6"></ui-input>
                <ui-textarea label="Description" name="description" :error="form.errors.get('description')" v-model="form.description"></ui-textarea>
            </ui-form-section>
        </ui-container>

        <ui-container class="py-4 flex justify-end space-x-6">
            <ui-button-new v-if="editMode" @click="edit(false)">Cancel</ui-button-new>
            <ui-button-new v-else @click.prevent="form.reset()">Reset</ui-button-new>
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">
                {{ editMode ? 'Save' : 'Create' }}
            </ui-button-new>
        </ui-container>
    </form>
</template>

<script>
import { Key } from '@models'

export default {
    props: {
        item: Object,
        edit: Function,
        addItem: Function,
    },
    data () {
        const initialData = this.item
            ? this.item.getFormAttributes()
            : {}

        return {
            form: new Form(initialData, async (form) => {
                if (this.editMode) {
                    await this.item.update(form.export())

                    this.edit(false)
                } else {
                    const key = await Key.create(form.export())
                    this.addItem(key, 0)

                    form.reset()
                }
            }),
        }
    },
    computed: {
        editMode () {
            return !! this.item
        },
    },
}
</script>
